import React, { Component } from "react";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";
import { Button, Message, Grid, Divider } from "semantic-ui-react";

import FormsInputsDropdown from "../../inputs/dropdown";
import { updateAdminPreferences } from "../../../../actions";
import { getErrorMessage } from "../../../../utils/api_error";

const yesNoOptions = [
  { text: "Yes", value: "Y" },
  { text: "No", value: "N" },
];

// Split out of the old combined profile form, which required a new password
// before it would save anything - so this setting could not be changed on its own.
class FormsUserPreferences extends Component {
  state = {
    success: false,
    error: false,
    errorMessage: "",
  };

  renderResult() {
    if (this.state.success) {
      return (
        <Message positive>
          <Message.Header>Preferences saved</Message.Header>
        </Message>
      );
    }
    if (this.state.error) {
      return <Message negative>{this.state.errorMessage}</Message>;
    }
  }

  render() {
    const { user } = this.props;
    return (
      <Formik
        enableReinitialize
        initialValues={{
          enableNewChatNotification: user.enableNewChatNotification || "Y",
        }}
        onSubmit={(values, actions) => {
          this.setState({ success: false, error: false, errorMessage: "" });
          this.props.updateAdminPreferences(
            {
              accessToken: user.accessToken,
              enableNewChatNotification: values.enableNewChatNotification,
            },
            (result, error) => {
              actions.setSubmitting(false);
              if (error) {
                this.setState({
                  error: true,
                  errorMessage: getErrorMessage(
                    error,
                    "We could not save your preferences. Please try again."
                  ),
                });
                return;
              }
              this.setState({ success: true });
            }
          );
        }}
        validateOnBlur={false}
        validateOnChange={false}
        render={({ isSubmitting }) => (
          <Form>
            <Grid container columns={2}>
              <Grid.Column width={16}>
                <Divider horizontal>Notification Preferences</Divider>
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="enableNewChatNotification"
                  label="Enable New Chat Notification"
                  options={yesNoOptions}
                  component={FormsInputsDropdown}
                  secondaryLabel=""
                />
              </Grid.Column>
              <Grid.Column verticalAlign="bottom">
                <Button
                  type="submit"
                  primary
                  fluid
                  loading={isSubmitting}
                  disabled={isSubmitting}>
                  Save Preferences
                </Button>
              </Grid.Column>
              <Grid.Column width={16}>{this.renderResult()}</Grid.Column>
            </Grid>
          </Form>
        )}
      />
    );
  }
}

export default connect(null, {
  updateAdminPreferences,
})(FormsUserPreferences);
